import {
	FREE_EDITION,
	STANDARD_EDITION,
} from '@jira/platform__application-editions/src/edition.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { expVal } from '@atlassian/jira-feature-experiments';
import { useIsArchived, useIssueKey } from '@atlassian/jira-issue-context-service/src/main.tsx';
import { useEdition, useProjectKey } from '@atlassian/jira-project-context-service/src/main.tsx';
import { useProjectPermissions } from '@atlassian/jira-project-permissions-service/src/main.tsx';
import { useFieldValue } from '@atlassian/jira-issue-field-base/src/services/field-value-service/index.tsx';

type useIsTwoStepIssueDeleteFreemiumExperimentEnabledProps = {
	isIssueArchivalEnabled?: boolean;
};

export const useIsTwoStepIssueDeleteFreemiumExperimentEnabled = ({
	isIssueArchivalEnabled = false,
}: useIsTwoStepIssueDeleteFreemiumExperimentEnabledProps): boolean => {
	const issueKey = useIssueKey();
	const projectKey = useProjectKey(issueKey);
	const edition = useEdition(projectKey, true);

	const isArchived = useIsArchived();

	const [issueType] = useFieldValue({ issueKey, fieldKey: 'issuetype' });
	const [permissions] = useProjectPermissions(projectKey);

	const isSubtask = issueType?.subtask;

	const isUneligibleForArchivalWithLicenseCheck =
		edition === FREE_EDITION || edition === STANDARD_EDITION || !isIssueArchivalEnabled;

	const isUneligibleForArchivalWithoutLicenseCheck =
		!(permissions.canArchiveIssue && !isSubtask && !isArchived) && !isIssueArchivalEnabled;

	const isUneligibleForIssueArchival = fg('extend_issue_archival_for_free_and_standard')
		? isUneligibleForArchivalWithoutLicenseCheck
		: isUneligibleForArchivalWithLicenseCheck;
	return (
		isUneligibleForIssueArchival &&
		expVal(
			'issue_deletion_two_step_process_for_free_standard',
			'isIssueDeleteExperimentFreemiumEnabled',
			false,
		)
	);
};
